import { render, staticRenderFns } from "./reduceEmissions.vue?vue&type=template&id=11f65a80&scoped=true&"
import script from "./reduceEmissions.vue?vue&type=script&lang=js&"
export * from "./reduceEmissions.vue?vue&type=script&lang=js&"
import style0 from "./reduceEmissions.vue?vue&type=style&index=0&id=11f65a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f65a80",
  null
  
)

export default component.exports